import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Only initialize Sentry in production
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://ce037ae8e7885da5bd9f2d912c10bed0@o4510783459295232.ingest.de.sentry.io/4510783466176592",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}

createRoot(document.getElementById("root")!).render(<App />);
